// XKeep: one keepsake cropped from the character's 4x2 keepsake sheet (keeps.jpg, 1200x900).
// `i` is the SHEET index 0-7 (route keepsake #k -> KORDER[ch][k] in rules.ts). Locked = greyed and blurred.
import type { JSX } from 'preact';
import type { CharId } from '@shared/types';
import { C } from '@shared/content/characters';
import { KEEPNAME } from '@shared/content/story';

export interface XKeepProps {
  ch: CharId;
  /** Sheet index 0-7. */
  i: number;
  /** Size in px (default 96). */
  s?: number;
  locked?: boolean;
  /** Corner radius (default 16% of s). */
  radius?: number;
  /** No drop shadow. */
  flat?: boolean;
  /** Alt text (default: the plain keepsake name, or "Not yet" when locked). */
  alt?: string;
  class?: string;
  style?: JSX.CSSProperties;
}

export function XKeep({ ch, i, s = 96, locked, radius, flat, alt, class: cls, style }: XKeepProps) {
  const ix = Math.max(0, Math.min(7, Math.round(i) || 0));
  const col = ix % 4, row = Math.floor(ix / 4);
  return (
    <div
      class={cls}
      style={{
        width: s, height: s, borderRadius: radius != null ? radius : Math.round(s * 0.16), overflow: 'hidden', position: 'relative',
        background: '#F1EBE0', boxShadow: flat ? 'none' : '0 8px 20px rgba(0,0,0,0.35)', opacity: locked ? 0.35 : 1,
        filter: locked ? 'grayscale(1) blur(2px)' : 'none', flex: 'none', ...style,
      }}
    >
      <img
        src={C[ch].assets.keeps}
        alt={alt != null ? alt : locked ? 'Not yet' : KEEPNAME[ch][ix]}
        draggable={false}
        style={{ position: 'absolute', width: s * 4, height: s * 3, maxWidth: 'none', left: -col * s, top: -Math.round(row * 1.5 * s + 0.25 * s) }}
      />
    </div>
  );
}
